import React from "react";

const zones = ["A", "B", "C", "D", "E", "F"];

const IoTSensing = () => {
  return (
    <div className="panel iot-sensing-panel">
      <div className="panel-header">
        <h3>IoT Sensing</h3>
        <button type="button" className="link-button">View Details</button>
      </div>
      <div className="zone-grid">
        {zones.map((zone, i) => (
          <div key={i} className="zone-item">
            <img
              src="/iotsensing.png"
              alt={`Test Zone ${zone}`}
            />
            <div className="zone-label">Test Zone {zone}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IoTSensing;
